import React, { useEffect, useState,useRef } from "react";
import CreateExerciseForm from "./CreateExerciseForm";
import CustomTemplateForm from "./CustomiseTemplateForm";
import QuizRunner from "../quiz/QuizRunner";
import ExerciseRunner from "./ExerciseRunner";
import WrittingQuiz from "../quiz/WrittingQuiz";
import TemplateInstructions from "./TemplateInstructions";
import Error from "../../erros/Error";
import { exerciseType } from "../../components/constants/constants";
import ActivateModel from "../../components/modals/ActivateaccountModel";
import { CreateQuizUrl, websocketUrl } from "../../libs/env";
import "react-toastify/dist/ReactToastify.css";
import { Col, Row } from "reactstrap";
import { w3cwebsocket as W3CWebSocket } from "websocket";
import { useHistory } from "react-router-dom";

const GenerateExercise = ({
  isLoaded,
  data,
  onSubmit,
  setIsSystemRedirection,
  isSystemRedirection,
  isSubmitting,
  onUpdate,
  Dropdownitems,
  GenerateQuiz,
  formError,
  IsGenerating,
  setIsGenerating,
  CreateQuiz,
  setIsSubmitting,
  setShowSocketData,
  ShowSocketData,
  IsFeedbackGenerating,
  setIsFeedbackGenerating,
  GenerateFeedback
}) => {
  let params = new URL(document.location).searchParams;
  let template_data = params.get("edit_template");
  let generated_data = params.get("g_ut");
  let use_template = params.get("use_template");
  const history = useHistory();
  const [UserActiveModal, setUserActiveModal] = useState(false);
  const UserActiveToggle = () => setUserActiveModal(!UserActiveModal);
  const [EndGptResponse, setEndGptResponse] = useState(false);
  const [IsQuizCreate, setIsQuizCreate] = useState(true);
  const [IsStopGenerating, setIsStopGenerating] = useState(false);
  const [IsRegenerating, setIsRegenerating] = useState(false);
  const [Qblinker, setQblinker] = useState(false);
  const [ChatgptError, setChatgptError] = useState("");
  const [formData, setFormData] = useState({
    cefr_level: "",
    exercise_type: "",
    time_allowed: "",
    topic: "",
    question_type: "",
    questions: "",
    options: "1",
    detail: "",
    grammar_type: "",
    voice_id: null,
    task_style: "",
    formality: "",
    recom_words: "",
    credits: "0",
    exercise_id: "",
    use_template: "",
    audio_text: "",
    exercise_title: "",
    action_value: "",
    vocab: "",
    question_reference_id: "",
    grammar_reference_id: "",
    socket_id: Dropdownitems?.user_id,
  });
  const [ExerciseData, setExerciseData] = useState({
    html_content: { content: "", isMounted: false },
    prompt_content: { content: "", isMounted: false },
    task_level: "",
    task_type: "",
    task_theme: "",
    recom_time: "",
    questions: [],
    status: "New",
    output_prompt: "",
    meta_data: {},
    q_type: "",
    task_style: "",
    formality: 0,
    recom_words: "",
    disable_form_fields: [],
    hide_task_level:false,
    ai_grading_task:false,
    sug_keywords:"",
    plain_text:"",
    voice_id: null,
    audio_text:"",
    g_audio_url:"",
    audio_creation:"",
    audio_file_name:"",
    content_img:"",
    image_file_name:"",
    dalle_prompt:"",
    socket_id: "",
    age_group: "",
    gpt_quick_actions: [],
    task_exercise_types: [],
    template_id: "",
    question_reference_id: "",
    grammar_reference_id: "",
    question_type: "",
    question_type_icon: ""
  });

  if(IsRegenerating)
  {
    setExerciseData((ExerciseData) => ({
      ...ExerciseData,
      html_content: { content: "", isMounted: false },
      prompt_content: { content: "", isMounted: false },
      audio_text: "",
      sug_keywords: "",
      plain_text: "",
      questions: [],
      start_questions: null,
    }));
    setChatgptError("");
    setIsRegenerating(false);
  }
  const ws = useRef(null);
  useEffect(() => {
    function startWebsocket(ws,user_id,IsStopGenerating) {
      // const user_id = window.sessionStorage.getItem("user_id");
      if(!ws.current || !ws.current?.url.includes(user_id))
      {
        ws.current = new W3CWebSocket(`${websocketUrl}${user_id}`);
      }
      // Handle incoming messages
      ws.current.onopen = () => {
        console.log("WebSocket Client Connected");
      };
      ws.current.onmessage = (event) => {
        if(IsStopGenerating)
        {
          console.log("send socket stop code",IsStopGenerating);
          ws.current.send(
            JSON.stringify({
              action: "stop",
            })
          );
        }
        if (ShowSocketData) {
          const data = JSON.parse(event.data);
          var data_questions = [];
          var data_answers = [];
          if (data?.chunk_response) {
            console.log("gpt_response", data?.chunk_response);
          }
          if (data?.type === "error") {
            setChatgptError(data?.message);
            console.log("chatgpt_error", data?.message);
          }
          if (data?.content_img) {
            setExerciseData((ExerciseData) => ({
              ...ExerciseData,
              content_img:  data?.content_img ? data?.content_img : "",
              image_file_name: data?.image_file_name ? data?.image_file_name : "",
            }));
          }
          if (data?.g_audio_url) {
            setExerciseData((ExerciseData) => ({
              ...ExerciseData,
              g_audio_url:  data?.g_audio_url ? data?.g_audio_url : "",
              audio_file_name: data?.audio_file_name ? data?.audio_file_name : "",
              audio_creation: data?.generate_audio_start ? true : false,
            }));
          }
          if (data?.q_type === "RadioBox" || data?.q_type === "CheckBox") {
            if (data?.q) {
              try {
                const answers = data?.q;
                setQblinker(false);
                for (let i = 0; i < answers.length; i++) {
                  data_answers = [];
                  const item = answers[i];
                  const q_id = item?.q_id;
                  const prompt = item.p;
                  const options = item.options;
                  for (const option_id in options) {
                    const option_label = options[option_id][0];
                    const option_value = options[option_id][1];
                    data_answers.push({
                      id: parseInt(q_id) + parseInt(option_id) + 110,
                      is_correct: option_value === 1 ? true : false,
                      number: parseInt(q_id),
                      prompt_content: option_label,
                      question_id: parseInt(q_id),
                    });
                  }
                  data_questions.push({
                    id: parseInt(q_id),
                    type: data?.q_type,
                    prompt_content: prompt,
                    correct_answer_score: "1.00",
                    possible_answers: data_answers,
                    task_grammar: item?.grammar_point ? item.grammar_point : "",
                    disable_question_numbering: item?.dis_ques_num === "True" ? true:false,
                    number: item?.number ? parseInt(item.number) : 0,
                    page: 1,
                    show_sequence: item?.sequence ? item.sequence : "ABC Sequence",
                    question_horizontal_display: item?.horiz_display === "True" ? true : false,
                    input_field_length: item?.field_length ? parseInt(item.field_length) : 20,
                    input_field_characters_limit: item?.field_char_limit ? parseInt(item.field_char_limit) : 150,
                    question_alignement: "Top",
                    question_options_randomize: item?.opt_randomize === "True" ? true : false,
                    verbatim_check: item?.ver_check === "True" ? true : false,
                  });
                }
              } catch {
                setQblinker(true);
                console.error("cannot fetch answers");
              }
            }
          } else if (data?.start_question) {
            if (data?.q) {
              try {
                const fill_in_questions = data?.q;
                for (let i = 0; i < fill_in_questions.length; i++) {
                  data_answers = [];
                  const item = fill_in_questions[i];
                  const q_id = item?.q_id;
                  const prompt = item.p;
                  const answers = item.m_words;
                  for (let j = 0; j < answers.length; j++) {
                    const answer_item = answers[j];
                    const mw_id = answer_item.mw_id;
                    const options = answer_item.options;
                    for (const option_id in options) {
                      const option_label = options[option_id][0];
                      const option_value = options[option_id][1];
                      data_answers.push({
                        id: i + option_id + 110,
                        is_correct: option_value === 1 ? true : false,
                        number: parseInt(mw_id),
                        prompt_content: option_label,
                        question_id: parseInt(q_id),
                      });
                    }
                  }
                  data_questions.push({
                    id: parseInt(q_id),
                    type: data?.q_type,
                    prompt_content: prompt,
                    correct_answer_score:
                      answers && answers?.length ? answers.length : "1.00",
                    possible_answers: data_answers,
                    task_grammar: item?.grammar_point ? item.grammar_point : "",
                    disable_question_numbering: item?.dis_ques_num === "True" ? true:false,
                    user_selected: [],
                    number: item?.number ? parseInt(item.number) : 0,
                    page: 1,
                    show_sequence: item?.sequence ? item.sequence : "ABC Sequence",
                    question_horizontal_display: item?.horiz_display === "True" ? true : false,
                    input_field_length: item?.field_length ? parseInt(item.field_length) : 20,
                    input_field_characters_limit: item?.field_char_limit ? parseInt(item.field_char_limit) : 150,
                    question_alignement: "Top",
                    question_options_randomize: item?.opt_randomize === "True" ? true : false,
                    verbatim_check: item?.ver_check === "True" ? true : false,
                  });
                }
              } catch {
                console.error("cannot fetch answers");
              }
            }
          } else {
            var additional_data;
            if (data?.q) {
              try {
                
                var answers;
                try{
                  answers = JSON.parse(data?.q);
                }
                catch{
                  const lastIndex = data?.q.lastIndexOf("}");
                  const newquestions = data?.q.slice(0, lastIndex) + data?.q.slice(lastIndex + 1);
                  try{
                    const startIndex = newquestions.indexOf("[");
                    const endIndex = newquestions.lastIndexOf("]") + 1;
                    // Extract the JSON data
                    const jsonData = newquestions.substring(startIndex, endIndex);
                    answers = JSON.parse(jsonData);
                  }
                  catch{
                      console.log('No JSON data found');
                  }
                }
                for (let i = 0; i < answers.length; i++) {
                  const item = answers[i];
                  if(item.grammar_point)
                  {
                    additional_data = item
                  }
                  else{
                  const q_id = item.q_id;
                  const options = item.options;
                  for (const option_id in options) {
                    const option_label = options[option_id][0];
                    const option_value = options[option_id][1];
                    data_answers.push({
                      id: i + option_id + 110,
                      is_correct: option_value === 1 ? true : false,
                      number: parseInt(q_id),
                      prompt_content: option_label,
                      question_id: 10,
                    });
                  }
                  }
                }
              } catch {
                console.log("please wait for answers");
              }
            }
            if (data?.p && data?.q_type) {
              data_questions = [
                {
                  id: 10,
                  type: data?.q_type,
                  prompt_content: data?.p,
                  correct_answer_score:
                    data_answers && data_answers?.length
                      ? data_answers?.length
                      : "1.00",
                  possible_answers: data_answers,
                  task_grammar: additional_data && additional_data.grammar_point ? additional_data.grammar_point : "",
                  disable_question_numbering: additional_data && additional_data.dis_ques_num === "True" ? true:false,
                  user_selected: [],
                  number: additional_data && additional_data.number ? parseInt(additional_data.number) : 0,
                  page: 1,
                  show_sequence: additional_data && additional_data.sequence ? additional_data.sequence : "ABC Sequence",
                  question_horizontal_display: additional_data && additional_data.horiz_display === "True" ? true : false,
                  input_field_length: additional_data && additional_data.field_length ? parseInt(additional_data.field_length) : 20,
                  input_field_characters_limit: additional_data && additional_data.field_char_limit ? parseInt(additional_data.field_char_limit) : 150,
                  question_alignement: "Top",
                  question_options_randomize: additional_data && additional_data.opt_randomize === "True" ? true : false,
                  verbatim_check: additional_data && additional_data.ver_check === "True" ? true : false,
                },
              ];
            }
          }
          if (data?.exercise_type) {
            setExerciseData((ExerciseData) => ({
              ...ExerciseData,
              task_level: data?.task_level ? data?.task_level : "",
              task_type: data?.exercise_type ? data?.exercise_type : "",
              task_theme: data?.topic ? data?.topic : "",
              recom_time: data?.recom_time ? data?.recom_time : "",
              task_style: data?.task_style ? data?.task_style : "",
              formality: data?.formality ? data?.formality : 0,
              recom_words: data?.recom_words ? data?.recom_words : "",
              prompt_content: {
                content: data?.title,
                isMounted: data?.i || data?.start_question || data?.p || data?.audio_text ? true : false,
              },
              html_content: {
                content: data?.i,
                isMounted: data?.start_question || data?.p ? true : false,
              },
              audio_text: data?.audio_text ? data?.audio_text : "",
              sug_keywords: data?.sug_words ? data?.sug_words : "",
              plain_text: data?.plain_text ? data?.plain_text : "",
              questions: data_questions,
              output_prompt: data?.output_prompt,
              meta_data: data?.metadata ? data?.metadata : {},
              q_type: data?.q_type ? data?.q_type : "",
              start_questions: data?.start_question
                ? data?.start_question
                : null,
            }));
          }

          if (data?.response_end === "response ended") {
            setEndGptResponse(true);
          }
        }
      };

      // Handle errors
      ws.current.onerror = (event) => {
        console.error("WebSocket error:", event);
      };
      ws.current.onclose = () => {
        console.log("WebSocket Connection Closed. Trying to reconnect...");
        // Attempt to reconnect every 5 seconds
        setTimeout(function () {
          ws.current = null; // Reset the WebSocket instance
          startWebsocket(ws,user_id,IsStopGenerating);
        }, 2000);
      };
      // Clean up on unmount
      return () => {
        ws.current.close();
      };
    }
    if (Dropdownitems.user_id) {
      startWebsocket(ws,Dropdownitems.user_id,IsStopGenerating);
    }
  }, [Dropdownitems, ShowSocketData,IsStopGenerating]);
  useEffect(() => {
    if(IsGenerating && ChatgptError)
    {
      setIsStopGenerating(true);
      setIsGenerating(false);
      setIsRegenerating(false);
    }
  },[ChatgptError,setIsGenerating,IsGenerating]);
  useEffect(() => {
    if (ExerciseData?.prompt_content?.content && !EndGptResponse) {
      window.addEventListener("beforeunload", alertUser);
      return () => {
        window.removeEventListener("beforeunload", alertUser);
      };
    }
  });
  const alertUser = (e) => {
    if (ExerciseData?.prompt_content?.content && !EndGptResponse) {
      e.preventDefault();
      e.returnValue = "";
    }
  };
  if (
    IsGenerating &&
    EndGptResponse &&
    ExerciseData?.task_type === exerciseType.LISTENING_TASK &&
    ExerciseData?.audio_text && !ExerciseData?.audio_creation
  ) {
    setIsGenerating(false);
    setEndGptResponse(false);
  }
  if (
    IsQuizCreate &&
    IsGenerating &&
    EndGptResponse &&
    (ExerciseData?.questions.length > 0 ||
      ExerciseData?.task_type === exerciseType.WRITING_TASK || 
      ExerciseData?.task_type === exerciseType.PRONUNCIATION_TASK ||
      ExerciseData?.task_type === exerciseType.SPEAKING_TASK)
  ) {
    if(ExerciseData?.task_type === exerciseType.LISTENING_TASK && ExerciseData?.g_audio_url)
    {
      setIsQuizCreate(false);
      CreateQuiz(ExerciseData, use_template);
    }
    else if (ExerciseData?.task_type !== exerciseType.LISTENING_TASK)
    {
      setIsQuizCreate(false);
      CreateQuiz(ExerciseData, use_template);
    }
  }
  const clearformData = (generate_quiz) => {
    // var domain = window.location.protocol + "//" + window.location.host;
    // var newUrl = domain + "/a/generate";
    if(generate_quiz){
      history.push("/a/generate?use_template=true");
    }
    else if (template_data === "true" || generated_data === "true") {
      if(!template_data)
      {
        history.push(`/a/edit-exercise/${data?.id}?edit_template=true`);
      }
    } else {
      history.push("/a/generate");
    }
  };
  const generate_button = () => {
    let form_submit = document.getElementById("SubmitForm");
    form_submit.click();
  };
  return (
    <>
      <Row
        className="g-0 custom_scroll"
      >
          <Col sm={12} 
            className={template_data === "true" || generated_data === "true" ||
            use_template === "true" ? "no-print f-col-lg-4 border-right-1": "f-col-lg-4 no-print border-right-1"}
          >
            <div class="col-12 p-4 stpy-3 border-bottom">
              <div class={`d-flex ${window.location.pathname.includes(CreateQuizUrl) ? "px-2" :"px-3"}`}>
                  <nav
                    Style='--bs-breadcrumb-divider: url(&#34;&#34;);'
                    aria-label="breadcrumb"
                  >
                    <ol class="breadcrumb mb-0 align-items-center flex-nowrap">
                      <li class="breadcrumb-item">
                        <a
                          id="breadcrumb_back"
                          href="/a/templates"
                          class="text-ldark text-decoration-none pe-2"
                        >
                          <b>Home</b>
                        </a>
                      </li>
                      {data && data.prompt_content ?(
                        <>
                        <svg width='35' height='20' viewBox='0 0 16 16' fill='none' xmlns='http://www.w3.org/2000/svg'>
                          <path d='M6 12L10 8L6 4' stroke='#D0D5DD' stroke-width='1.33333' stroke-linecap='round' stroke-linejoin='round'/>
                        </svg>
                        <li
                          class="exercise-text breadcrumb-item rounded-5 py-1 px-2 fw-600"
                          style={{backgroundColor: "#EDF2FF", color: "#2E58D4"}}
                          aria-current="page"
                        >
                          <span>{data.prompt_content}</span>
                        </li>
                        </>
                      ): window.location.pathname.includes(CreateQuizUrl) && (
                        <>
                        <svg width='35' height='20' viewBox='0 0 16 16' fill='none' xmlns='http://www.w3.org/2000/svg'>
                          <path d='M6 12L10 8L6 4' stroke='#D0D5DD' stroke-width='1.33333' stroke-linecap='round' stroke-linejoin='round'/>
                        </svg>
                        <li
                          class="exercise-text breadcrumb-item rounded-5 py-1 px-2 fw-600 ms-2"
                          style={{backgroundColor: "#EDF2FF", color: "#2E58D4"}}
                          aria-current="page"
                        >
                          <span>Custom task</span>
                        </li>
                        </>
                      )}
                    </ol>
                  </nav>
                      {/* <h1 class="fs-5"> <b>Create your own task from the selected template</b></h1> */}
              </div>
            </div>
            {template_data === "true" ||
            generated_data === "true" ||
            use_template === "true" ? (
              <CustomTemplateForm
                Dropdownitems={Dropdownitems}
                GenerateQuiz={GenerateQuiz}
                data={data}
                setExerciseData={setExerciseData}
                formError={formError}
                IsGenerating={IsGenerating}
                UserActiveToggle={UserActiveToggle}
                setShowSocketData={setShowSocketData}
                formData={formData}
                setFormData={setFormData}
                clearformData={clearformData}
                setIsStopGenerating={setIsStopGenerating}
                IsStopGenerating={IsStopGenerating}
                setIsGenerating={setIsGenerating}
                IsRegenerating={IsRegenerating}
                setIsRegenerating={setIsRegenerating}
                generate_button={generate_button}
              />
            ) : (
              <CreateExerciseForm
                Dropdownitems={Dropdownitems}
                GenerateQuiz={GenerateQuiz}
                data={data}
                setExerciseData={setExerciseData}
                formError={formError}
                IsGenerating={IsGenerating}
                UserActiveToggle={UserActiveToggle}
                setShowSocketData={setShowSocketData}
                formData={formData}
                setFormData={setFormData}
                clearformData={clearformData}
                setIsStopGenerating={setIsStopGenerating}
                IsStopGenerating={IsStopGenerating}
                setIsGenerating={setIsGenerating}
                IsRegenerating={IsRegenerating}
                setIsRegenerating={setIsRegenerating}
                generate_button={generate_button}
              />
            )}
          </Col>
          <Col sm={12} 
              className={"f-col-lg-8 bg-lblue no-print pb-3"}
          >
            {/* <div class="border-l-bottom rounded-0 no-print">
              <div class="d-flex p-4 px-5">
                <div class="col-11">
                  <h1 class="fs-5">
                    {" "}
                    <b>Output: Review and use your new exercise</b>
                  </h1>
                  <span class="text-lgrey">
                    Optionally edit your exercise, then print for class use or
                    assign directly to your students.
                  </span>
                </div>
                {window.location.pathname.includes(GenaiUrl) &&
                template_data !== "true" ? (
                  <div class="col-1 text-center align-self-end">
                    <span
                      onClick={() => {
                        clearformData();
                        setFormData({});
                      }}
                      class="btn bg-white text-lgrey"
                    >
                      Clear
                    </span>
                  </div>
                ) : null}
              </div>
            </div>
            {template_data === "true" && (
              <div className="col-12 px-5 pt-4 fs-5">
                <b>
                  <span className="text-darkblue">Template example</span>. Customise
                  the template to generate a similar quiz.
                </b>
              </div>
            )} */}
            {window.location.pathname.includes(CreateQuizUrl) ? (
              <>
                {IsGenerating || IsStopGenerating || ExerciseData?.audio_text ||
                ExerciseData?.questions.length > 0 ||
                (ExerciseData?.task_type === exerciseType.WRITING_TASK &&
                  ExerciseData?.prompt_content.isMounted) ||
                  (ExerciseData?.task_type === exerciseType.PRONUNCIATION_TASK &&
                    ExerciseData?.prompt_content.isMounted) ||
                    (ExerciseData?.task_type === exerciseType.SPEAKING_TASK &&
                      ExerciseData?.prompt_content.isMounted) ? (
                  <ExerciseRunner
                    setIsSystemRedirection={setIsSystemRedirection}
                    isSystemRedirection={isSystemRedirection}
                    data={ExerciseData}
                    isLoaded={isLoaded}
                    setExerciseData={setExerciseData}
                    setFormData={setFormData}
                    onSubmit={onSubmit}
                    isSubmitting={isSubmitting}
                    onUpdate={onUpdate}
                    EndGptResponse={EndGptResponse}
                    CreateQuiz={CreateQuiz}
                    setIsSubmitting={setIsSubmitting}
                    Qblinker={Qblinker}
                    IsGenerating={IsGenerating}
                    ChatgptError={ChatgptError}
                  />
                ) : (
                      <TemplateInstructions
                        setIsSystemRedirection={setIsSystemRedirection}
                        isSystemRedirection={isSystemRedirection}
                        data={data}
                        isLoaded={isLoaded}
                        onSubmit={onSubmit}
                        isSubmitting={isSubmitting}
                        onUpdate={onUpdate} 
                        template_data={template_data} 
                        use_template={use_template}
                        generated_data={generated_data}
                      />
                  // <Row className="g-0 justify-content-center align-items-center h-75">
                  //     <Col className="col-7">
                  //       <div class="col-12 d-flex p-0 align-items-center rounded-5 mt-5 form-control">
                  //         <div class="p-3 bg-lblue right-side-rounded">
                  //         <svg width="21" height="34" viewBox="0 0 21 34" fill="none" xmlns="http://www.w3.org/2000/svg">
                  //           <path opacity="0.2" d="M10.8028 14.6206L12.1542 0.678063C12.1836 0.383778 11.9992 0.110092 11.7157 0.0257306C11.4322 -0.0586312 11.1291 0.0698736 10.9917 0.331788L11.4346 0.563977M10.8028 14.6206L11.4346 0.563977M10.8028 14.6206H10.7544V15.1206L10.8028 14.6206ZM11.4346 0.563977L0.513914 21.4528L0.512933 21.4547C0.494952 21.4887 0.495027 21.5317 0.517599 21.5691C0.538486 21.6038 0.576733 21.6256 0.618186 21.6256H7.91352H8.47548L8.41013 22.1837L7.10056 33.3685L7.10048 33.3692C7.09432 33.4212 7.12378 33.4722 7.17587 33.4924C7.19028 33.4978 7.20361 33.5 7.21803 33.5C7.257 33.5 7.29271 33.4813 7.31434 33.4502L7.31515 33.449L19.6264 15.8076C19.6265 15.8075 19.6265 15.8073 19.6266 15.8072C19.653 15.7689 19.6547 15.722 19.6354 15.6852C19.6142 15.6448 19.5732 15.6206 19.5299 15.6206H10.7544H10.2035L10.2567 15.0724L11.6565 0.629828L11.6567 0.628311C11.6621 0.573681 11.6277 0.521221 11.5731 0.504962C11.5196 0.489034 11.4614 0.512964 11.4347 0.563769C11.4346 0.563838 11.4346 0.563907 11.4346 0.563977ZM1.19529 20.6579L0.812714 21.3896H1.63838H8.60901C8.64234 21.3896 8.67499 21.4038 8.69857 21.4301C8.71963 21.4537 8.73058 21.4862 8.7265 21.5209L8.72648 21.521L7.62193 30.9549L8.52858 31.2991L18.756 16.6427L19.3045 15.8566H18.3459H10.0746C10.0411 15.8566 10.0104 15.8427 9.9888 15.8188C9.96443 15.7917 9.95421 15.7584 9.95719 15.7268C9.9572 15.7267 9.9572 15.7266 9.95721 15.7266L11.1167 3.76234L10.1759 3.48243L1.19529 20.6579Z" fill="none" stroke="black"/>
                  //         </svg>

                  //         </div>
                  //         <div class="p-2 ps-3">
                  //           <span class="mb-2 fs-6 fw-600">
                  //             Your generated quiz will be shown here
                  //           </span>
                  //           <div class="d-flex">
                  //             <p class="fs-6 text-lgrey">
                  //               Edit the settings and click{" "}
                  //               <button class="border-0 bg-white text-darkblue" href="#" onClick={() => {generate_button()}}>
                  //                 generate
                  //               </button>
                  //             </p>
                  //           </div>
                  //         </div>
                  //       </div>
                  //     </Col>
                  //   </Row>
                )}
              </>
            ) : data.task_type === exerciseType.WRITING_TASK ? (
              <WrittingQuiz
                setIsSystemRedirection={setIsSystemRedirection}
                isSystemRedirection={isSystemRedirection}
                data={data}
                isLoaded={isLoaded}
                onSubmit={onSubmit}
                isSubmitting={isSubmitting}
                onUpdate={onUpdate}
              />
            ) : data.detail ? (
              <Error data={data} isLoaded={isLoaded} />
            ) : (
              <QuizRunner
                setIsSystemRedirection={setIsSystemRedirection}
                isSystemRedirection={isSystemRedirection}
                data={data}
                isLoaded={isLoaded}
                onSubmit={onSubmit}
                isSubmitting={isSubmitting}
                onUpdate={onUpdate}
                GenerateFeedback={GenerateFeedback}
                IsFeedbackGenerating={IsFeedbackGenerating}
                setIsFeedbackGenerating={setIsFeedbackGenerating}
              />
            )}
          </Col>
        <ActivateModel
          data={data}
          isOpen={UserActiveModal}
          toggle={UserActiveToggle}
        />
      </Row>
    </>
  );
};

export default GenerateExercise;
